import axios, { AxiosError, AxiosResponse } from 'axios';
import TaskType from '../../../models/TaskType';
import { interceptor } from '../../../utils/axios.interceptor';
import { taskTypeEndPoint } from '../../../utils/endPoints';

export const taskTypeInstance = axios.create();
interceptor(taskTypeInstance);

export class TaskTypeService {
  /**
   * Used to create a new Task type
   * @param taskType object
   * @returns code responded by server or 400
   */
  async createTaskType(
    taskType: object,
  ): Promise<{ status: boolean; data: AxiosResponse | unknown }> {
    try {
      let result;
      const response = await taskTypeInstance.post(taskTypeEndPoint, taskType);
      if (response.status === 201) {
        result = { status: true, data: response.data as TaskResponse };
      } else {
        result = { status: false, data: [] };
      }
      return result;
    } catch (error) {
      return {
        status: false,
        data: 'Error',
      };
    }
  }
  /**
   * Used to get the task types
   * @returns Task list
   */
  async getTaskType(): Promise<any> {
    try {
      const response = await taskTypeInstance.get(taskTypeEndPoint);
      return { status: true, data: response.data.results };
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }
  /**
   * Used to update the task type
   * @param task: Task type object
   * @returns the task type object updated
   */
  async updateTaskType(
    taskType: TaskType,
  ): Promise<{ status: boolean; data: AxiosResponse | unknown }> {
    try {
      let result;
      const response = await taskTypeInstance.put(
        `${taskTypeEndPoint}/${taskType.id}`,
        { tipotarea: taskType.tipotarea, activo: taskType.activo, color: taskType.color },
      );
      if (response.status === 200) {
        result = { status: true, data: response.data as TaskResponse };
      } else {
        result = { status: false, data: [] };
      }
      return result;
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }

  /**
   * Delete TaskType by id
   * @returns the task type object updated
   */
  async deleteTaskType(taskType: TaskType): Promise<any> {
    try {
      let result;
      const response = await taskTypeInstance.delete(
        `${taskTypeEndPoint}/${taskType.id}`,
      );
      if (response.status === 202) {
        result = { status: true, data: response.data as TaskResponse };
      } else {
        result = { status: false, data: [] };
      }
      return result;
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }
}
